var map = {
	"./BaseBannerTitle.vue": "3981",
	"./BaseBlock.vue": "057b",
	"./BaseButton.vue": "4629",
	"./BaseIcon.vue": "b02e",
	"./BaseList.vue": "81e7",
	"./BasePlan.vue": "fb60",
	"./BaseSectionTitle.vue": "c4d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee8e";